<template>
  <div class="dashboard">
    <row>
      <div class="col-lg-3 col-xs-6" v-for="precondition in preconditions" :key="precondition.id" >
        <va-small-box
          :color="customClass(precondition.status,'pre')"
          :icon="customClass(precondition.preCondition,'icon')"
          :title="$t(precondition.preCondition)"
          :description="getDescriptions(precondition.status,precondition.preCondition)"
          @more-click="clickToSmallBox"
          :moreText="$t(customClass(precondition.duration,'duration'))">
        </va-small-box>
      </div>
  
   
    </row>
      <!-- Modal Forward to Consultant -->
   
   <!-- END Modal Forward to Consultant -->

 <task :patientInfo="patientInfo" name="bsForward" :userType="userType"></task> 
   <!-- Modal Medicine Prescribtion Form -->
  <prescription :patientInfo="patientInfo" name="bsMedicine"></prescription> 
   <!-- END Modal Medicine Prescription form -->
<div class="row">
  
		<div class="col-lg-6">
    	 <div class="well profile">
            <div class="col-sm-12">
                <div class="col-xs-12 col-sm-8">
                    <h2><i class="fa fa-female"></i>{{patientInfo.name}}  &nbsp; <span v-html="showTrend(patientInfo.trend)"></span></h2>
                    <p><strong>{{$t('contactNumber')}}: </strong><a :href="`tel:+${ patientInfo.contactNumber }`"><i class="fa fa-mobile fa-2x"></i>&nbsp;{{patientInfo.contactNumber}}</a> &nbsp; | &nbsp;<a :href="`tel:+${ patientInfo.enterBy }`"><i class="fa fa-mobile fa-2x"></i>&nbsp;{{patientInfo.enterBy}}</a> </p>
                    <p><strong> {{$t('address')}}: </strong>{{patientInfo.locationName}} {{patientInfo.address}} {{patientInfo.city}} {{patientInfo.zipcode}} {{patientInfo.state}} </p>
                    <p><strong>{{$t('physical')}}: </strong>
                        <span class="tags">{{$t('heightData')[[patientInfo.height]]}}</span> 
                        <span :class="customClass(patientInfo.wight)">{{$t('weightData')[[patientInfo.wight]]}}</span>
                       
                    </p>
                     <p><strong>{{$t('age')}}: </strong> <span :class="customClass(patientInfo.yob,'age')">{{new Date().getFullYear() - patientInfo.yob}}  {{$t('years')}}</span> </p>

                    
                </div>             
                <div class="col-xs-12 col-sm-4 text-center">
                    <figure>
                        
                        <figcaption class="ratings">
                            <p>{{$t('risk')}}:{{$t('riskFactor')[[calRiskFactor(patientInfo.riskFactor)]]}}
                           {{$t('symptom')}}:{{$t('riskFactor')[[calRiskFactor(patientInfo.currentRating)]]}}
                            </p>
                        </figcaption>
                    </figure>
                </div>
            </div>  
            
            <div class="col-xs-12 divider text-center">
                <div class="col-xs-12 col-sm-3 emphasis">
                    <h4><strong> {{ moment(patientInfo.insertTime).startOf('hour').fromNow()   }}</strong></h4>                    
                    <p><small>{{$t('registerDate')}}</small></p>
                    <button class="btn btn-success btn-block" @click="openTaskFrom(3,$event)"><span class="fa fa-user-md"></span> {{$t('consultant')}} </button>
                </div>
                <div class="col-xs-12 col-sm-3 emphasis">
                    <h4><strong>{{ patientInfo.updateTime>0 ? moment(patientInfo.updateTime).startOf('hour').fromNow():'Never'}}</strong></h4>                    
                    <p><small>{{$t('lastUpdate')}}</small></p>
                    <button class="btn btn-info btn-block" @click="openTaskFrom(4,$event)"><span class="fa fa-ambulance"></span> {{$t('ambulance')}} </button>
                </div>
                <div class="col-xs-12 col-sm-3 emphasis">
                    <h4><strong>43</strong></h4>                    
                    <p><small>{{$t('lastUpdate')}}</small></p>
                    <div class="btn-group dropup btn-block">
                      <button type="button" class="btn btn-primary btn-block" @click="openTaskFrom(5,$event)"><span class="fa fa-motorcycle"></span> {{$t('filed_staff')}}  </button>
                      
                     
                    </div>
                </div>
                <div class="col-xs-12 col-sm-3 emphasis">
                    <h4><strong>43</strong></h4>                    
                    <p><small>{{$t('lastUpdate')}}</small></p>
                    <div class="btn-group dropup btn-block">
                      <button type="button" class="btn btn-warning btn-block" @click="openTaskFrom(6,$event)"><span class="fa fa-hospital-o"></span> {{$t('prescribtion')}}  </button>
                      
                     
                    </div>
                </div>
            </div>
    	 </div>      
         
		</div>
    <div class='col-lg-6'>
            <p class='text-center'>
              <strong>{{$t('Symptoms')}}</strong>
            </p>
            <va-chart
              :chart-config='chartData'
            v-if="chartData.data.datasets.length > 0">
            </va-chart>
        <div class="center" v-else >
       <i class="fa fa-spinner fa-spin fa-5x text-primary" aria-hidden="true"></i>
        </div>
          </div>          
	</div>
    <row>
      <section class="col-lg-6 connectedSortable ui-sortable">
        <va-chat-box :patient="patientInfo"></va-chat-box>
      </section>
      <section class="col-lg-6 connectedSortable ui-sortable">
        <div class="row">
        <Rooms />
       <Video :username="patientInfo.name"/>
       <Logs />
     </div>
    
      </section>
    </row>
  </div>
</template>

<script>
import VASmallBox from '../widgets/VASmallBox.vue'
import VAChatBox from '../widgets/VAChatBox.vue'
import VATodoList from '../widgets/VATodoList.vue'
import VAQuickMail from '../widgets/VAQuickMail.vue'
import VACalendar from '../widgets/VACalendar.vue'
import { services } from '../../src/vuex/api'
import VAInfoBox from '../widgets/VAInfoBox.vue'
import VAChart from '../components/VAChart'
import i18n from '../plugins/i18n' 
// TWILLO VIDEO CHAT
import Rooms from '../components/twillo/Rooms'
import Video from '../components/twillo/Video'
import PrescriptionForm from '../widgets/PrescriptionForm.vue'
import TaskForm from '../widgets/TaskForm.vue'
import Logs from '../components/twillo/Logs'
import AddRoom from '../components/twillo/AddRoom'
import { calRiskFactor ,calSymptom , showTrend ,showAgeGroup } from '../../src/lib/functions'
// END TWILLO VIDEO CHAT
// import moment from 'moment'
export default {
  name: 'PatientDetails',
   mounted: function () {
      var self = this
      let uri = window.location.href.split('?')
      if (uri.length === 2){
      let vars = uri[1].split('&')
      let tmp = ''
      vars.forEach(function(v){
        tmp = v.split('=')
        if ( tmp.length === 2 ) {
          if ( tmp[0] === 'id' ){
            self.id = tmp[1]
           }
         }
       })
      }
      this.getPatientDetails(self.id)
      this.getPatientPreCondition(self.id)
      this.getPatientSymtoms(self.id)
     // this.getLanguage()
      if ( localStorage.getItem('lan') != null ) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language
      console.log('mounted: got here')
    },
  data () {
    return {
       patientInfo:{},
       instructions:[],
       preconditions:[],
       symtops:[],
       userType:-1,
       error:'',
       chartData:{
            type: 'line',
            data: {
                datasets: []
              }
          },
       id: null,
       calRiskFactor,
       calSymptom , 
       showTrend 
      
    }
  },
  methods: {
     openTaskFrom:function(data,e){
       var self = this
        self.userType = data
       e.preventDefault()
    
    if (data === 6 ){
       $('#bsMedicine').modal('show')
    } else {
      $('#bsForward').modal('show')
    }
  },
    clickToSmallBox () {
      alert('click!!!: clickToSmallBox')
    },
    getDescriptions(val,group){
        if (group === 'close_contact'){
          return i18n.t('closeContactData')[[val]]
        } else if (group === 'location'){
          return i18n.t('locationData')[[val]]
        } else if (group === 'age'){
          return i18n.t('ageGroupDate')[[val]]
        } else {
          return i18n.t('preconditionStatus')[[val]]
        }
    },
    customClass(val , sec = 'weight'){
      if (sec === 'weight'){
          if (val > -1 && val < 2 ){
            return 'tags alert-success'
          } else if (val >= 2 && val < 3){
            return 'tags alert-warning'
          } else {
            return 'tags alert-danger'
          }
      } else if (sec === 'pre'){
          if (val === 0 ){
            return 'green'
          } else if (val === 1  ){
            return 'aqua'
          } else if (val === 2  ){
            return 'yellow'
          } else if (val === 3 ){
            return 'red'
          } else {
            return 'aqua'
          }
      } else if (sec === 'age'){
        var age = new Date().getFullYear() - val
          if (age > 6 && age < 25 ){
            return 'tags alert-success'
          } else if ( age >= 25 && age < 40){
            return 'tags alert-primary'
          } else if ( age >= 40 && age < 55){
            return 'tags alert-warning'
          } else {
            return 'tags alert-danger'
          }
       } else if (sec === 'icon'){
          if (val === 'diabetics' ){
            return 'tint'
          } else if (val === 'heart' ){
            return 'heartbeat'
          } else if (val === 'weight' ){
            return 'weight'
           } else if (val === 'hypertension' ){
            return 'tachometer-alt'
          } else if (val === 'close_contact' ){
            return 'head-side-cough'
           } else if (val === 'location' ){
            return 'map'
          } else if (val === 'age' ){
            return 'child'
           } else if (val === 'lungs' ){
            return 'lungs'
          } else {
            return 'tint'
          }
         } else if (sec === 'duration'){
          if (val === 0 ){
            return 'duration_na'
          } else if (val === 1 ){
            return 'duration_less_5'
          } else if (val === 2 ){
            return 'duration_more_5'
           } 
      }
    },
    getPatientDetails: function ( patientId = '' ) {
    var self = this
     services.patients.getPatientDetails(patientId) //  .getPatientInfo()
    .then(function (response) {
      // console.log(JSON.stringify(response.data))
      self.patientInfo = response.data
    })
    .catch(function (error) {
      console.log(error)
    })
  },
   getPatientPreCondition: function ( patientId = '' ) {
    var self = this
     services.patients.getPrecondition({patientId :patientId} ) //  .getPatientInfo()
    .then(function (response) {
    var ageRank = showAgeGroup( self.patientInfo.yob )
    // console.log(ageRank)
     var ageData = {
        "preCondition" : "age",
        "status" : ageRank,
        "duration" : 2,
        "active" : 1
    }
      self.preconditions = response.data
       self.preconditions.push(ageData)
    })
    .catch(function (error) {
      console.log(error)
    })
  },
   getPatientSymtoms: function ( patientId = '' ) {
    var self = this
     console.log('YYYYYYYYYYYYYYYY  I AM IN SYMPTOMS')
     services.patients.getSymptom({patientId :patientId} ) //  .getPatientInfo()
    .then(function (response) {
       console.log('SHOWING  I AM INSIDE  SYMPTOMS')
       console.log(response.data)
       
      
      self.symtops = response.data
      var timedifference = new Date().getTimezoneOffset() * 60 * 1000
     
      var fever_ = []
      var cough_ = []
      var breath_ = []
      var chest_ = []
      var conditionData = i18n.t('symptomData') // ['None', 'Mild', 'Moderate', 'Severe','']// ['Normal', 'Mild', 'Mild++', 'Severe']
      
      var consciousness_ = []
      var now = new Date()
       var utcTimestamp = Date.UTC(now.getUTCFullYear(),now.getUTCMonth(), now.getUTCDate() ,   
      now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds()) - timedifference
      // var nowUTC = now.getTime() // + now.getTimezoneOffset() * 60 * 1000
      self.symtops.forEach(element => {
        // var duration = moment.duration(new Date().getUTCHours() * 60 * 60 * 1000 - element.insertTime)

        var hours = Math.floor((utcTimestamp - element.insertTime) / 3600000) // now.diff(element.insertTime, 'hours') // moment(element.insertTime).fromNow() // duration.asHours()
          if (element.symptom.trim() === 'fever' ){
            fever_.push({ y:conditionData[element.status] , x : hours } )
            // console.log(fever_)
            // console.log(element.insertTime + ' ->FEVER   HIGH FEVER =' + hours)
            cough_.push({ y:conditionData[element.status] , x : hours } )
           } else if (element.symptom === 'breath'){
            breath_.push({ y:conditionData[element.status], x : hours } )
           } else if (element.symptom === 'chest_pain'){
            chest_.push({ y:conditionData[element.status], x : hours } )
           } else if (element.symptom === 'confusion'){
            consciousness_.push({ y: conditionData[element.status] , x : hours } )
          }
       })
     
      var fever = {label: i18n.t('fever'), borderColor: '#0e14c7',data:fever_ ,borderDash:[2,2],backgroundColor:'#0e14c7',fill:false}
      var cough = {label: i18n.t('cough'), borderColor: '#f80079',data:cough_ ,borderDash:[4,4],backgroundColor:'#f80079',fill:false}
      var breath = {label: i18n.t('breathing_problem'), borderColor: 'rgba(199, 19, 6,0.9)',data:breath_ ,borderDash:[5,5],backgroundColor:'rgba(199, 19, 6,0.9)',fill:false}
      var chest = {label: i18n.t('chest_pain'), borderColor: '#f5bd05',data:chest_ ,borderDash:[6,6],backgroundColor:'#f5bd05',fill:false}
      var consciousness = {label: i18n.t('consciousness'), borderColor: '#f8ff79',data:consciousness_ ,borderDash:[7,7],backgroundColor:'#f8ff79',fill:false}
      var cLabels = conditionData.reverse()
      var chart = {
            type: 'line',
            data: {
                datasets: [fever,cough,chest,breath,consciousness]
              },
             options: {
          scales: {
            xAxes: [{
              type: 'linear',
              position: 'bottom',
              scaleLabel: {
                display: true,
                labelString: i18n.t('hour')
              }
            }],
            yAxes: [{
            display: true,
            type: 'category',
            ticks: {
            min: cLabels[0],
            max: cLabels[4]
            },
            labels: cLabels ,
            scaleLabel: {
              display: true,
              labelString: i18n.t('condition')
            }
          }]
          }
        }
          }
            self.chartData = chart
      console.log(self.chartData)
      console.log('FINAL  I AM INSIDE  SYMPTOMS')
    })
    .catch(function (error) {
      console.log(error)
    })
  }
  },
  components: {
    'va-small-box': VASmallBox,
    'va-chat-box': VAChatBox,
    'va-todo-list': VATodoList,
    'va-quick-mail': VAQuickMail,
    'va-calendar': VACalendar,
    'va-info-box': VAInfoBox ,
    'Rooms': Rooms,
    'Logs': Logs,
    'Video': Video,
    'AddRoom': AddRoom,
    'va-chart':VAChart,
    'prescription' : PrescriptionForm,
    'task' :TaskForm
    
  }
}

</script>

<style scoped>

.profile 
{
    min-height: 355px;
    display: inline-block;
    }
figcaption.ratings
{
    margin-top:20px;
    }
figcaption.ratings a
{
    color:#f1c40f;
    font-size:11px;
    }
figcaption.ratings a:hover
{
    color:#f39c12;
    text-decoration:none;
    }
.divider 
{
    border-top:1px solid rgba(0,0,0,0.1);
    }
.emphasis 
{
    border-top: 4px solid transparent;
    }
.emphasis:hover 
{
    border-top: 4px solid #1abc9c;
    }
.emphasis h2
{
    margin-bottom:0;
    }
span.tags 
{
    background: #1abc9c;
    border-radius: 2px;
    color: #f5f5f5;
    font-weight: bold;
    padding: 2px 4px;
    }
.dropdown-menu 
{
    background-color: #34495e;    
    box-shadow: none;
    -webkit-box-shadow: none;
    width: 250px;
    margin-left: -125px;
    left: 50%;
    }
.dropdown-menu .divider 
{
    background:none;    
    }
.dropdown-menu>li>a
{
    color:#f5f5f5;
    }
.dropup .dropdown-menu 
{
    margin-bottom:10px;
    }
.dropup .dropdown-menu:before 
{
    content: "";
    border-top: 10px solid #34495e;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    position: absolute;
    bottom: -10px;
    left: 50%;
    margin-left: -10px;
    z-index: 10;
    }

</style>
<style>
.modal-dialog {
    width: 1200px !important;
}
.input-group-text,.input-group-select{
  width: 20%;
  margin-left: 5px;
}
.center {
 display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// PatientDetails.vue?7a28ccd7